import { Container } from "@mui/material";
import React from "react";
import { useScreenSize } from "src/hooks/useScreenSize";

type Props = {
  subTitle: string;
  title: string;
  image: string;
};

const DiscountPageHeader = ({ subTitle, title, image }: Props) => {
  const smAndDown = useScreenSize("sm", "down");

  return (
    <div className="discounts__header">
      {!smAndDown && (
        <Container className="discounts__header--left">
          <div className="discounts__header--left-content">
            <h4>{subTitle}</h4>
            <h1>{title}</h1>
          </div>
        </Container>
      )}

      {smAndDown && (
        <div className="discounts__header--left">
          <h4>{subTitle}</h4>
          <h1>{title}</h1>
        </div>
      )}

      <div
        className="discounts__header--right"
        style={{ backgroundImage: `url(${image})` }}
      ></div>
    </div>
  );
};

export default DiscountPageHeader;
